/**
 * Libellés, badges et pagination partagés par les vues mandat.
 * Aligné sur Recommandation.STATUT_CHOICES / RACIClient.STATUT_CHOICES.
 */

export const MANDAT_PAGE_SIZES = [10, 25, 50, 100];

export const MANDAT_STATUTS = {
  non_commencee: 'Non commencée',
  en_cours: 'En cours',
  terminee: 'Terminée',
  en_attente: 'En attente',
  annulee: 'Annulée',
  en_retard: 'En retard',
};

const STATUT_TONE = {
  non_commencee: 'muted',
  en_cours: 'info',
  terminee: 'success',
  en_attente: 'warn',
  annulee: 'danger',
  en_retard: 'danger',
};

export function formatMandatStatut(statut) {
  const key = String(statut || '').trim();
  return MANDAT_STATUTS[key] || statut || '—';
}

export function mandatStatutClass(statut) {
  const tone = STATUT_TONE[String(statut || '').trim()] || 'muted';
  return `mandat-badge mandat-badge--${tone}`;
}

export function formatMandatDate(date, { long: useLong = false } = {}) {
  if (!date) return 'Non définie';
  const opts = useLong
    ? { year: 'numeric', month: 'long', day: 'numeric' }
    : { year: 'numeric', month: 'short', day: 'numeric' };
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return 'Non définie';
  return parsed.toLocaleDateString('fr-FR', opts);
}
